/** Nr. + specification share one grid region; `ImportVehicleSummary` lays them out inside. */
export const importPricingGrid = {
  columns: 7,
  specificationSpan: 4,
  cellSpan: 1,
} as const;
